import axios from '@/axios';

const API_BASE = `${process.env.VUE_APP_API_BASE_URL}/api/onboarding`;

const state = {
  session: null,
  status: null,
  loading: false,
  error: null,
};

const mutations = {
  setSession(state, payload) {
    state.session = payload;
    state.status = payload?.status || null;
  },
  setStatus(state, value) {
    state.status = value;
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setError(state, value) {
    state.error = value;
  },
};

const actions = {
  async signup({ commit }, payload) {
    commit('setLoading', true);
    commit('setError', null);
    try {
      const { data } = await axios.post(`${API_BASE}/signup/`, payload);
      commit('setSession', data.session);
      return data;
    } catch (error) {
      commit('setError', error.response?.data?.error || error.message);
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async fetchStatus({ commit }, publicToken) {
    commit('setLoading', true);
    commit('setError', null);
    try {
      const { data } = await axios.get(`${API_BASE}/status/${publicToken}/`);
      commit('setSession', data);
      return data;
    } catch (error) {
      commit('setError', error.response?.data?.error || error.message);
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async getWizardState({ commit }) {
    const { data } = await axios.get(`${API_BASE}/wizard/`);
    return data;
  },

  async saveWizardState(_, payload) {
    const { data } = await axios.post(`${API_BASE}/wizard/`, payload);
    return data;
  },
};

const getters = {
  onboardingSession: (state) => state.session,
  onboardingStatus: (state) => state.status,
  onboardingLoading: (state) => state.loading,
  onboardingError: (state) => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
